export default {
  footprint: {
    title: "%{name}'s årlige fotavtrykk er",
    description: '%{name} har et årlig fotavtrykk på %{co2} kgCO\u2082e ',
    levels: {
      1: 'bedre enn gjennomsnittet',
      0: 'gjennomsnittlig',
      '-1': 'dårligere enn gjennomsnittet',
    },
  },
};
